import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M6.683,4.66l15.239,0l-4.675,14.681l-15.167,0l4.604,-14.681Z",
		style: {
			fill: "none",
			fillRule: "nonzero",
			stroke: "currentColor",
			strokeWidth: "1.33px"
		}
	}) })
});
export default SvgPlane;
